import React, { useState, useEffect } from "react"

import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap"
import { Link } from "react-router-dom"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import SweetAlert from "react-bootstrap-sweetalert"
import moment from "moment"
// import actions
import { connect } from 'react-redux';
import {
	setAllCategories,
	setAllMerchants
} from "../../store/cms-actions/postActions";
import { CheckPermission } from "../Permissions/CheckPermissions";
import { CircularProgress } from "@material-ui/core";
import { FaPen , FaRegTrashAlt, FaPlus, FaCloudUploadAlt} from "react-icons/fa";


const FRxHomeSingleBanners = (props) => {
  const sortOptions = [
    { id: 1, value: "enabled", label: "Enabled" },
    { id: 2, value: "all", label: "All" }

  ]
  const [sortBy, setSortBy] = useState(sortOptions[0].value)
  const [token, setToken] = useState('')
  const [data, setData] = useState([])
  const [success_msg, setsuccess_msg] = useState(false)
  const [errorMessage, SetErrorMessage] = useState('')
  const [errorMsgAlert, setErrorMsgAlert] = useState(false)
  const [ItemForDelete, setItemForDelete] = useState('')
  const [del, setDelete] = useState(false)
  const [loading,setloading]=useState(true)



  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken")
    setToken(token)
    getCarouselBanners(token)
  }, [sortBy, success_msg])

  // useEffect(() => {
  //   autoDisableBanners(data, token)
  // }, [setData, sortBy, token])


  const autoDisableBanners = (data, token) => {
    data?.map((item) => {
      const timestamp = moment().unix(item.unpublished_at)
      const currentDate = new Date().getTime()
      if (item?.item_status == "Y" && item?.unpublished_at !== "null" && item?.unpublished_at !== null && item?.unpublished_at !== undefined) {
        if (timestamp < currentDate) {
          changeDate(item, token)
        }
      }
    })
  }

  function changeDate(item, token) {
    var myHeaders = new Headers();

    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append("Cookie", "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208");

    var formdata = new FormData();
    formdata.append("path", "tiles_banners/update");
    formdata.append("env", "staging");
    formdata.append("page", item?.page);
    formdata.append("item_status", "N");
    formdata.append("description", item?.description);
    formdata.append("item_id", item?.item_id);
    formdata.append("item_version", item?.item_version);
    formdata.append("deeplink", item?.deeplink);
    formdata.append("published_at", item?.published_at);
    formdata.append("unpublished_at", item?.unpublished_at);
    formdata.append("sort_order", 0);
    formdata.append("api", "true");

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then(response => {
        if (response.status == 200) {
          setSortBy("enabled")
        } else {
        }
        response.json()
      })
      .then(result => { })
      .catch(error => console.log('error', error));
  }

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        onConfirm={() => {
          setsuccess_msg(false)
        }}
        onCancel={() => {
          // props?.history?.push(`/single-banners/${selectedSection?.path}`)
          setsuccess_msg(false)
        }}
      >
        {"Single banner deleted."}
      </SweetAlert>
    )
  }
  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorMsgAlert(false)
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    )
  }

  const handleConfirmation = () => {
    return (
      <SweetAlert
        title="Warning"
        warning
        showCancel={true}
        showConfirm={true}
        confirmBtnText="Delete"
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="secondary"
        onConfirm={() => {
          console.log("Item is: ", ItemForDelete)
          deleteEntry(ItemForDelete?.item_id, token)
          setDelete(false)
        }}
        onCancel={() => setDelete(false)}
        show={true}>
        {"Are you sure you want to delete ?"}
      </SweetAlert>
    )
  };

  const getCarouselBanners = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("Cookie", "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208");

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub?path=tiles_banners&env=production`, requestOptions)
      .then(response => response.json())
      .then(result => {
        setloading(false)
        let tempData = []
        if (result) {
          result?.banners?.map((item) => {
            console.log("Checking result of get single banners temp data", item)
            if (item.page == "home_tiles" || item.page == "home_single") {
              console.log("Checking result of get single banners temp data 2222", item)
              tempData = [...tempData, item]
            }
          })
          
          /*Sorting according to postion and date */
          tempData.sort((a, b) => {
            if (a.sort_order == b.sort_order) {
              return (Date.parse(b.published_at) - Date.parse(a.published_at))
            }
            else {
              return a.sort_order - b.sort_order;
            }
          })
          // autoDisableBanners(tempData, token)
          setData(tempData)
        }
      })
      .catch(error => console.log('error', error));
  }

  const deleteEntry = (ID, token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub?path=tiles_banners/delete_banner&id=${ID}`, requestOptions)
      .then(response => {
        if (response.status == 200) {
          setsuccess_msg(true)
        } else {
          setErrorMsgAlert(true)
        }
        response.text()
      })
      .then(result => console.log(result))
      .catch(error => console.log('error', error));

  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Single Banners" breadcrumbItem="FRx Home" />

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <CardTitle className="h4">
                    <Row>
                      <Col lg={6} md={12} sm={12}>
                        <Button
                        disabled={!CheckPermission("tiles_banners","add")}
                          className="btn btn-success waves-effect waves-light"
                          onClick={() => {
                            props?.history?.push("/single-banners/add-single-banners", { FRxHomeSingleBanners: true })
                          }}
                        >
                          <FaPlus size={12} />{" "}
                          Add FRx Home Banner
                        </Button>
                      </Col>
                      <Col lg={6} md={12} sm={12}
                        style={{ textAlign: "right" }}>
                        <div className="mb-3">
                          {/* <Label>Discount Type</Label> */}
                          <label htmlFor="cars">Status</label>

                          <select name="cars" id="cars" defaultValue="" style={{ width: 80, height: 30, marginLeft: 10 }} onChange={(e) => { setSortBy(e.target.value) }}>
                            {sortOptions?.map((item, index) => {
                              return (
                                <option key={index} value={item.value}>{item.label}</option>
                              )
                            })}
                          </select>
                        </div>
                      </Col>
                    </Row>
                  </CardTitle>

                  {loading ? <div role="status" style={{ textAlign: "center" }}>
                        <CircularProgress
                         size={50} value={100} color={"black"}
                        />
                      </div> :<div className="table-responsive">
                    <table className="table table-bordered border-primary mb-0">

                      <thead>
                        <tr>
                          <th>Image</th>
                          <th>Title</th>
                          <th style={{width:"14%"}}>Publish At</th>
                          <th style={{width:"14%"}}>Unpublish At</th>
                          <th>Status</th>
                          <th>Action</th>
                          {/* <th>Position</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((item, index) => {
                          if (sortBy == "enabled") {
                            if (item?.item_status !== "Y") {
                              return
                            }
                          }
                          return (
                            <tr key={index}>
                              <th scope="row">
                                <img
                                  src={item?.image_url}
                                  style={{ width: 250 }}
                                  alt=""
                                />
                              </th>
                              <td>{item?.title}</td>
                              <td>{moment(item?.published_at).format("DD/MM/YYYY h:mm a")}</td>
                              <td>{item?.unpublished_at == "null" ? "Never-Ending" : moment(item?.unpublished_at).format("DD/MM/YYYY h:mm a")}</td>
                              <td>
                                {item?.item_status == "Y" ?
                                  <Button color="success" className="btn-soft-success waves-effect waves-light">Enabled</Button>
                                  :
                                  <Button color="danger" className="btn-soft-danger waves-effect waves-light">Disabled</Button>
                                }
                              </td>
                              <td>
                                <Row>
                                  <div className="d-flex justify-content-around">
                                    {CheckPermission("tiles_banners","update")&&<div style={{ width: 30, textAlign: "center" }}
                                      className=" text-primary"
                                      onClick={() => {
                                        props?.history?.push("/single-banners/edit-single-banners", { item: item, FRxHomeSingleBanners: true })
                                      }}>
                                      <a className="font-size-18"
                                        onClick={() => {
                                          props?.history?.push("/single-banners/edit-single-banners", { item: item, FRxHomeSingleBanners: true })
                                        }}
                                      ><FaPen /></a></div>}

                                    {CheckPermission("tiles_banners","delete")&&<div style={{ width: 30, textAlign: "center" }} >
                                      {/* onClick={() => { deleteEntry(item?.item_id, token) }} */}
                                      <Link className="px-2 text-danger"><i className="font-size-18" onClick={() => {
                                        setItemForDelete(item)
                                        setDelete(true)
                                      }}><FaRegTrashAlt /></i></Link>
                                    </div>}
                                  </div>
                                </Row>
                              </td>
                              {success_msg ? (
                                renderSuccessAlert()
                              )
                                :
                                null
                              }
                              {errorMsgAlert ? (
                                renderFailureAlert()
                              )
                                :
                                null
                              }
                              {/* <td>{item?.sort_order}</td> */}
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        {del ? handleConfirmation() : null}
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
	const { allCategories, allMerchants } = state.rootReducers1
	return { allCategories, allMerchants }
};

const actions = {
	setAllCategories,
	setAllMerchants,
};

export default connect(mapStateToProps, actions)(FRxHomeSingleBanners)

